import { Pipe, PipeTransform } from '@angular/core';
import { Visit } from '../entities/visit';

@Pipe({
    name: 'filterVisit',
    pure: false
})
export class FilterVisitPipe implements PipeTransform {
    transform(visits: Visit[], filterQuery: string): any {
        if (!visits || !filterQuery) {
            return visits;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return visits.filter(visit => 
                visit.idCustom.indexOf(filterQuery) > -1 ||
                (visit.vehicle && visit.vehicle.name && visit.vehicle.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
                (visit.driver && visit.driver.name && visit.driver.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) ||
                (visit.visitGroup && visit.visitGroup.name && visit.visitGroup.name.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1));
        //return items.filter(item => item.title.indexOf(filter.title) !== -1);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/pipes/filter-visit-directive.ts